module.exports = __webpack_public_path__ + "img/1-4.6775e27e.jpg";